const { event } = require("jquery");

$(function () {
  const confirmButton = $("#js-confirm-overlay-button");
  const cancelButton = $("#js-cancel-button");
  const container = $("#js-confirm-overlay");
  const containerContent = $(".confirm-overlay__overlay");
  const toggleBodyOverflow = (isHidden) =>
    (document.documentElement.style.overflow = isHidden ? "hidden" : "");

  confirmButton.on("click", function () {
    toggleBodyOverflow(true);
    trapFocus(containerContent[0]);
    container.toggleClass("confirm-overlay--hidden");
  });

  cancelButton.on("click", function () {
    toggleBodyOverflow(false);
    container.toggleClass("confirm-overlay--hidden");
  });

  container.on("click", function () {
    toggleBodyOverflow(false);
    container.toggleClass("confirm-overlay--hidden");
  });
  containerContent.on("click", function (event) {
    event.stopPropagation();
  });
});

function trapFocus(element) {
  const focusableEls = element.querySelectorAll(
    'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="submit"]:not([disabled]), select:not([disabled])'
  );
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  const KEYCODE_TAB = 9;

  element.addEventListener("keydown", function (e) {
    const isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      /* shift + tab */ if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } /* tab */ else {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  });
}
